import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1b9c5e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e1b9c5e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b9c5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b9c5e6')) {
      api.createRecord('e1b9c5e6', component.options)
    } else {
      api.reload('e1b9c5e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1b9c5e6&scoped=true", function () {
      api.rerender('e1b9c5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabFooter/index.vue"
export default component.exports